import React from "react";
import { RDTBrandOptions } from "utils/constant";

const TableComponent = ({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) => {
  const getTotal = (field) => {
    return reportsData.reduce(
      (total, item) => total + Number(item[field] || 0),
      0,
    );
  };

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case "nasional":
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama BKK</th>
                <th>Jum BKK melapor</th>
                <th>Jum BKK pemeriksaan mikroskopis</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Jum BKK pemeriksaan RDT</th>
                <th>Jum BKK SPO pembersihan dan penyimpanan kaca objek</th>
                <th>Jum BKK SPO pembuatan sediaan darah</th>
                <th>Jum BKK SPO pewarnaan sediaan darah</th>
                <th>
                  Jum BKK SPO pembacaan dan pelaporan hasil sediaan darah
                  malaria
                </th>
                <th>Jum BKK SPO uji kualitas giemsa</th>
                <th>Jum BKK SPO uji kualitas minyak imersi</th>
                <th>Jum BKK SPO uji kualitas methanol</th>
                <th>Jum BKK SPO uji kualitas pH buffer</th>
                <th>Jum BKK SPO penggunaan dan perawatan mikroskop</th>
                <th>Jum BKK SPO pelaksanaan K3</th>
                <th>Jum BKK SPO uji RDT</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.bkk_induk}</td>
                    <td>{item?.jumlah_lapor}</td>
                    <td>{item?.priksa_mikros_ya}</td>
                    <td>{item?.total_jum_mikros_baik}</td>
                    <td>{item?.keg_prksa_rdt_ya}</td>
                    <td>{item?.spo_kaca_objek_ya}</td>
                    <td>{item?.spo_pmbtn_darah_ya}</td>
                    <td>{item?.spo_pwrn_darah_ya}</td>
                    <td>{item?.spo_pbcn_darah_ya}</td>
                    <td>{item?.spo_giemsa_ya}</td>
                    <td>{item?.spo_imersi_ya}</td>
                    <td>{item?.spo_methanol_ya}</td>
                    <td>{item?.spo_phbuffer_ya}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros_ya}</td>
                    <td>{item?.spo_k3malaria_ya}</td>
                    <td>{item?.spo_rdt_ya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumlah_lapor")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("priksa_mikros_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("total_jum_mikros_baik")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("keg_prksa_rdt_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_kaca_objek_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pmbtn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pwrn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pbcn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_giemsa_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_imersi_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_methanol_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_phbuffer_ya")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pgunaan_prwtan_mikros_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_k3malaria_ya")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_rdt_ya")}</td>
              </tr>
            </tbody>
          </>
        );
      case "induk":
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama BKK</th>
                <th>Jum BKK melapor</th>
                <th>Jum BKK pemeriksaan mikroskopis</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Jum BKK pemeriksaan RDT</th>
                <th>Jum BKK SPO pembersihan dan penyimpanan kaca objek</th>
                <th>Jum BKK SPO pembuatan sediaan darah</th>
                <th>Jum BKK SPO pewarnaan sediaan darah</th>
                <th>
                  Jum BKK SPO pembacaan dan pelaporan hasil sediaan darah
                  malaria
                </th>
                <th>Jum BKK SPO uji kualitas giemsa</th>
                <th>Jum BKK SPO uji kualitas minyak imersi</th>
                <th>Jum BKK SPO uji kualitas methanol</th>
                <th>Jum BKK SPO uji kualitas pH buffer</th>
                <th>Jum BKK SPO penggunaan dan perawatan mikroskop</th>
                <th>Jum BKK SPO pelaksanaan K3</th>
                <th>Jum BKK SPO uji RDT</th>
              </tr>
            </thead>
            <tbody>
              {reportsData.length !== 0 ? (
                reportsData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.bkk_induk}</td>
                    <td>{item?.jumlah_lapor}</td>
                    <td>{item?.priksa_mikros_ya}</td>
                    <td>{item?.total_jum_mikros_baik}</td>
                    <td>{item?.keg_prksa_rdt_ya}</td>
                    <td>{item?.spo_kaca_objek_ya}</td>
                    <td>{item?.spo_pmbtn_darah_ya}</td>
                    <td>{item?.spo_pwrn_darah_ya}</td>
                    <td>{item?.spo_pbcn_darah_ya}</td>
                    <td>{item?.spo_giemsa_ya}</td>
                    <td>{item?.spo_imersi_ya}</td>
                    <td>{item?.spo_methanol_ya}</td>
                    <td>{item?.spo_phbuffer_ya}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros_ya}</td>
                    <td>{item?.spo_k3malaria_ya}</td>
                    <td>{item?.spo_rdt_ya}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
              <tr style={{ backgroundColor: "#43766C" }}>
                <td style={{ color: "#FFF" }} colSpan={2}>
                  Total
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("jumlah_lapor")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("priksa_mikros_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("total_jum_mikros_baik")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("keg_prksa_rdt_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_kaca_objek_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pmbtn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pwrn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pbcn_darah_ya")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_giemsa_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_imersi_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_methanol_ya")}</td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_phbuffer_ya")}</td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_pgunaan_prwtan_mikros_ya")}
                </td>
                <td style={{ color: "#FFF" }}>
                  {getTotal("spo_k3malaria_ya")}
                </td>
                <td style={{ color: "#FFF" }}>{getTotal("spo_rdt_ya")}</td>
              </tr>
            </tbody>
          </>
        );
      default:
        // wilker level
        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama BKK</th>
                <th>Pemeriksaan Mikroskopis</th>
                <th>Jum mikroskopis keadaan baik</th>
                <th>Melaksanakan pemeriksaan RDT</th>
                <th>SPO pembersihan dan penyimpanan kaca objek</th>
                <th>SPO pembuatan sediaan darah</th>
                <th>SPO pewarnaan sediaan darah</th>
                <th>SPO pembacaan dan pelaporan hasil sediaan darah malaria</th>
                <th>SPO uji kualitas giemsa</th>
                <th>SPO uji kualitas minyak imersi</th>
                <th>SPO uji kualitas methanol</th>
                <th>SPO uji kualitas pH buffer</th>
                <th>SPO penggunaan dan perawatan mikroskop</th>
                <th>SPO pelaksanaan K3</th>
                <th>SPO uji RDT</th>
                <th>Merek RDT yang digunakan</th>
                <th>Merek RDT lainnya</th>
              </tr>
            </thead>

            <tbody>
              {reportsData.length !== 0 ? (
                reportsData.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.nama_bkk}</td>
                    <td>{item?.priksa_mikros}</td>
                    <td>{item?.jum_mikros_baik}</td>
                    <td>{item?.keg_prksa_rdt}</td>
                    <td>{item?.spo_kaca_objek}</td>
                    <td>{item?.spo_pmbtn_darah}</td>
                    <td>{item?.spo_pwrn_darah}</td>
                    <td>{item?.spo_pbcn_darah}</td>
                    <td>{item?.spo_giemsa}</td>
                    <td>{item?.spo_imersi}</td>
                    <td>{item?.spo_methanol}</td>
                    <td>{item?.spo_phbuffer}</td>
                    <td>{item?.spo_pgunaan_prwtan_mikros}</td>
                    <td>{item?.spo_k3malaria}</td>
                    <td>{item?.spo_rdt}</td>
                    <td>
                      {item?.nama_rdt
                        ? item?.nama_rdt
                        : RDTBrandOptions.find(
                            (opt) => opt.value === item?.kd_rdt,
                          )?.label || null}
                    </td>
                    <td>{item?.merk_rdt_lain}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
          </>
        );
    }
  };

  let levelName = "";
  if (currentLevel === "nasional") {
    levelName = "Nasional";
  } else if (currentLevel === "induk") {
    levelName = "BKK Induk";
  } else {
    levelName = "BKK Wilker";
  }

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: "0" }}>
              <h3>
                SISMAL v4, Laporan Data Dasar Laboratorium Pemeriksaan Malaria
              </h3>
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Level
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              : {levelName}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              Induk
            </th>
            <th style={{ border: "none", paddingTop: 0, paddingBottom: 0 }}>
              :{" "}
              {!reportInfo?.induk
                ? "Semua BKK Induk"
                : reportInfo?.induk?.split("|")[1]}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Wilker</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              :{" "}
              {!reportInfo?.wilker
                ? "Semua BKK Wilker"
                : reportInfo?.wilker
                    ?.split(",")
                    .map((item) => item?.split("|")[1])
                    .join(", ")}
            </th>
          </tr>
        </tbody>
      </table>
      <table>{renderTableByLevel()}</table>
    </div>
  );
};

export default TableComponent;
